import CART_ICON_DART from "@assets/svg/shopping_cart_icon_dart.svg"
import Image from "next/image"

type Props = { totalItems?: number | 0 }

function CartButtonTemplate({ totalItems }: Props) {
  return (
    <>
      <div className="relative w-8">
        <Image src={CART_ICON_DART} alt="cart_icon" />
        <div
          className={`absolute bottom-4 left-4 bg-red-500 font-medium text-white rounded-full flex items-center justify-center shadow-md ${
            (totalItems || 0) < 10
              ? "w-4 h-4 text-[10px]"
              : "w-5 h-5 text-[11px]"
          }`}
        >
          {totalItems}
        </div>
      </div>
      <div className="lg:flex hidden text-[14px]">
        <div>Giỏ hàng</div>
      </div>
    </>
  )
}

export default CartButtonTemplate
